// @ts-expect-error - Automatic, Please fix when editing this file
const selectLocation = (state) => state?.router?.location?.pathname ?? null;

export default selectLocation;
